import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { useServerBilling } from '@/api/useServerBilling';
import Select from '@/components/forms/Select';
import Button from '@/components/misc/Button';
import { SelectInterface } from '@/interfaces/InterfacesLocal';
import { RegisterBillingInterface } from '@/interfaces/ServerInterfaces';
import { useAppSelector } from '@/store/hooks';

export const DispatchSelectedModal = ({
                                   close,
                                   registerBillingList,
                                   refreshList,
                               }: {
    close: Function
    registerBillingList: RegisterBillingInterface[]
    refreshList: Function
}) => {
    const { areas } = useAppSelector((state) => state.nomenclator)
    const { business } = useAppSelector((state) => state.init)
    const areasSelect: SelectInterface[] = areas
        .filter((item) => item.type === 'SALE')
        .map((item) => ({ id: item.id, name: item.name }))
    const { handleSubmit, control } = useForm()
    const precision = Number(
        business?.configurationsKey.find(
            (item) => item.key === 'precission_after_coma'
        )?.value
    )
    const {
        sendPredispatchSelected,
        isFetching,
        sendCalculateCubaje,
        isLoading,
        cubajeDetails,
    } = useServerBilling()
    const preDispatchedList = registerBillingList.filter(
        (item) => !item.isPreDispatched && item.isPreReceipt
    )

    const comp = (amountDispatches: number, amountOrdersMove: number) => (
        <div>
            Predespachos enviados correctamente <br />
            Prefacturas procesadas: {amountOrdersMove} <br />
            Productos predespachados: {amountDispatches}
        </div>
    )
    const onSubmit: SubmitHandler<Record<string, string | number>> = (data) => {
        const { saleArea } = data
        sendPredispatchSelected(
            Number(saleArea),
            preDispatchedList.map((item) => item.id),
            comp,
            refreshList
        )
    }
    const onClickDetailsButton = () => {
        sendCalculateCubaje(preDispatchedList.map((item) => item.id))
    }
    return (
        <div>
            <h2 className="mb-2 text-left text-xl font-semibold text-slate-600">
                {'Predespachar selección'}
            </h2>
            <form onSubmit={handleSubmit(onSubmit)} className={'flex flex-col'}>
                <div className="mt-5 grid grid-cols-1 gap-5">
                    <Select
                        name="saleArea"
                        label="Área de venta"
                        control={control}
                        rules={{ required: 'Este campo es requerido' }}
                        data={areasSelect}
                    />

                    <h3
                        className={
                            'text-sm font-medium text-gray-700 first-letter:uppercase'
                        }
                    >
                        Cantidad de prefacturas seleccionadas: {preDispatchedList.length}
                    </h3>
                </div>

                <div className="mt-5 w-full">
                    <Button
                        color="white"
                        outline
                        textColor={'slate-900'}
                        name={'Detalles'}
                        loading={isLoading}
                        full
                        className={'border-2 border-slate-600'}
                        action={() => onClickDetailsButton()}
                        disabled={isLoading}
                    />
                </div>

                {cubajeDetails && (
                    <div className={'mt-5'}>
                        <p
                            className={
                                'text-sm font-medium text-gray-700 first-letter:uppercase'
                            }
                        >
                            Cantidad de ítems:{' '}
                            <span className={'font-semibold'}>
                {cubajeDetails.amountProducts}
              </span>
                        </p>
                        <p
                            className={
                                'text-sm font-medium text-gray-700 first-letter:uppercase'
                            }
                        >
                            Cubicaje total:{' '}
                            <span className={'font-semibold'}>
                {Number(cubajeDetails.totalCubaje).toFixed(precision)} m&sup3;
              </span>
                        </p>
                    </div>
                )}

                <div className="mt-8 w-1/2 self-end">
                    <Button
                        color="slate-600"
                        type="submit"
                        name={'Aceptar'}
                        loading={isFetching}
                        disabled={isFetching || preDispatchedList.length === 0}
                        full
                    />
                </div>
            </form>
        </div>
    )
}